<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="login wow zoomIn" data-wow-duration="1.5s">
                    <div class="row justify-content-center">
                        <div class="col-md-7">
                            <h1 class="login__sub-title text-left mb-3">Forgot password?</h1>
                            <p>Enter the email associated with your account and we’ll send you password reset instructions.</p>
                            <div class="form">
                                <form>
                                    <label class="form-group">
                                        <span class="form-label">Your Email</span>
                                        <input type="email" class="form-control" v-model="email">
                                    </label>
                                    <div class="form-group">
                                        <button
                                            type="submit"
                                            class="btn btn_golden w-100"
                                            @click.prevent="resetPassword"
                                        ><span>Send Reset Instructions</span></button>
                                    </div>
                                    <div class="form-group text-center pt-3">
                                        <p><b><a href="/login">Return to Login</a></b></p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import RegisterAndLoginServices from "../../services/RegisterAndLoginServices";

export default defineComponent({
    name: "ForgotPasswordForm",
    data() {
        return {
            email: null
        }
    },
    methods: {
        async resetPassword() {
            if (!this.email) {
                return
            }
            try {
                await RegisterAndLoginServices.resetPassword()
                this.$showSuccessMessage('The instructions was send to your email')
                window.location.href = `/login`


            } catch {
                this.$showErrorMessage('The instructions was send to your email')
            }
        }
    }
})
</script>



<style scoped>

</style>
